import { render, staticRenderFns } from "./DynamicMetadataFields.vue?vue&type=template&id=64b4ce18&scoped=true&"
import script from "./DynamicMetadataFields.vue?vue&type=script&lang=js&"
export * from "./DynamicMetadataFields.vue?vue&type=script&lang=js&"
import style0 from "./DynamicMetadataFields.vue?vue&type=style&index=0&id=64b4ce18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b4ce18",
  null
  
)

export default component.exports